import React from 'react';
import {createPortal} from 'react-dom';
import {Button} from '../../styles/button';
import {Text} from '../../styles/text';
import {Layout} from '../../styles/layout';
import {modalTextColor, primaryColor} from '../../utils/variables';
import {formatMoney} from './modeStorage';
import * as S from './styles';
import {ProductPickerItem, ProductPickerVariation} from './types';

interface Props {
    product: ProductPickerItem;
    selectedId?: number;
    onSelect: (variation: ProductPickerVariation) => void;
    onCancel?: () => void;
    onConfirm?: () => void;
    confirmDisabled?: boolean;
    /** Render as centered modal over the page (needed inside clipped table footers) */
    asModal?: boolean;
}

const VariationPicker = ({
    product,
    selectedId,
    onSelect,
    onCancel,
    onConfirm,
    confirmDisabled,
    asModal = false,
}: Props) => {
    const content = (
        <S.VariationBox>
            <Layout vertical between={4}>
                <Text extent="S" weight="bold" color={primaryColor}>
                    Выберите вариацию
                </Text>
                <Text extent="S" color={modalTextColor}>
                    {product.name}
                </Text>
            </Layout>

            {(product.variations_combinations || []).length === 0 ? (
                <S.EmptyState>У этого товара нет доступных вариаций</S.EmptyState>
            ) : (
                <S.VariationOptions>
                    {(product.variations_combinations || []).map((variation) => (
                        <S.VariationChip
                            key={variation.id}
                            type="button"
                            $active={selectedId === variation.id}
                            onClick={() => onSelect(variation)}
                        >
                            <S.VariationChipName>
                                {variation.display_name}
                            </S.VariationChipName>
                            {variation.price != null && (
                                <S.VariationChipPrice>
                                    Сумма: {formatMoney(variation.price)}
                                </S.VariationChipPrice>
                            )}
                        </S.VariationChip>
                    ))}
                </S.VariationOptions>
            )}

            {(onCancel || onConfirm) && (
                <Layout hAlign="flex-end" between={8}>
                    {onCancel && (
                        <Button heightSize="32px" onClick={onCancel} type="button">
                            Отмена
                        </Button>
                    )}
                    {onConfirm && (
                        <Button
                            heightSize="32px"
                            onClick={onConfirm}
                            disabled={confirmDisabled}
                            type="button"
                        >
                            Добавить
                        </Button>
                    )}
                </Layout>
            )}
        </S.VariationBox>
    );

    if (!asModal) {
        return content;
    }

    return createPortal(
        <S.VariationOverlay onClick={onCancel}>
            <S.VariationDialog onClick={(e) => e.stopPropagation()}>
                {content}
            </S.VariationDialog>
        </S.VariationOverlay>,
        document.body,
    );
};

export default VariationPicker;
